import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Signup from './Signup'
import Signin from './Signin'
import UserStatus from './UserStatus'
import Dashboard from './Dashboard'
import { sportActions } from './_actions'

import './App.css';

class App extends Component {
	componentDidMount() {
		const { dispatch, loggedIn, jwtToken } = this.props;
		if (loggedIn && jwtToken){
			dispatch(sportActions.getAll(jwtToken));
		}
	}
	
	componentDidUpdate(prevProps) {
		const { dispatch, loggedIn, loggingIn, jwtToken, availableSports, isLoading } = this.props;
		if (!loggingIn && !isLoading && loggedIn && jwtToken && availableSports && availableSports.length === 0) {
			dispatch(sportActions.getAll(jwtToken));
		}
  }

  render() {
		const { loggedIn, jwtToken, availableSports } = this.props;
    return (
				<MuiThemeProvider className="App">
					<div>
						<Signin />
						<Signup/>
      		  <UserStatus />
						{ loggedIn &&
						<Dashboard jwtToken={jwtToken} sports={availableSports} />
						}
					</div>
      	</MuiThemeProvider>
    );
  }
}

function mapStateToProps(state) {
		//console.log("App State: ", state)
		const { authentication } = state;
		const { loggedIn, loggingIn } = authentication;
		if (authentication.session){
			const { idToken } = authentication.session;
			const { jwtToken } = idToken;
			let availableSports = [];
			const { sports } = state;
			const { isLoading } = sports;
			if (sports.items){
				availableSports = sports.items;
			}
			
			return {
				...state,
				loggedIn,
				loggingIn,
				jwtToken,
				availableSports,
				isLoading
			}
		}
		return {
			...state,
			loggedIn
		}
}
const connectedApp = connect(mapStateToProps)(App);

export default connectedApp;



// WEBPACK FOOTER //
// ./src/App.js